export const has = (object, key) => object ? hasOwnProperty.call(object, key) : false;